import React from "react";
import styled from "styled-components";
const Toggle = ({ vegOnly, setVegOnly, size = 1 }) => {
  return (
    <Container size={size}>
      <input
        type="checkbox"
        id="toggle"
        checked={vegOnly}
        // isChecked={vegOnly}
        onChange={() => setVegOnly(!vegOnly)}
      />
      <label htmlFor="toggle"></label>
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  width: ${(props) => 50 * props.size + "px"};
  height: ${(props) => 50 * props.size + "px"};
  label {
    /* background-color: #d41d00; */
    background-color: #888888;
  }
  input {
    visibility: hidden;
    width: 0.1px;
    /* display: none; */
    &:checked + label {
      transform: rotate(360deg);
      background-color: #008000;
      /* border-color: #0f0; */
      &:before {
        transform: translateX(200%);
        background-color: #fff;
      }
    }
  }

  label {
    display: flex;
    width: 100%;
    height: 50%;
    /* border: 1px solid; */
    border-radius: 99em;
    position: relative;
    transition: transform 0.75s ease-in-out;
    transform-origin: 50% 50%;
    cursor: pointer;

    &:before {
      transition: transform 0.75s ease;
      transition-delay: 0.5s;
      content: "";
      display: block;
      position: absolute;
      width: 25%;
      height: 50%;
      background-color: #fff;
      border-radius: 50%;
      top: ${(props) => 6 * props.size + "px"};
      left: ${(props) => 6 * props.size + "px"};
    }
  }
`;
export default Toggle;
